{
  "name": "news",
  "version": "1.0.1",
  "scripts": {
    "start": "ng serve --host 0.0.0.0",
    "build:tribuna": "ng build --configuration production-tribuna",
    "build:tribuna:ssr": "ng build --configuration production-tribuna && ./post-build.sh",
    "eda": "ng serve --configuration eda --port 4201",
    "build:eda": "ng build --configuration production-eda",
    "fecaza": "ng serve --configuration fecaza --port 4202",
    "build:fecaza": "ng build --configuration production-fecaza",
    "test": "ng test",
    "lint": "ng lint",
    "lint fix": "ng lint --fix",
    "e2e": "ng e2e",
    "ssr": "npm run build:tribuna --omit=dev && node dist/server/server.mjs",
    "build:stats": "ng build --stats-json",
    "analyze": "ng build -c development --stats-json --verbose && webpack-bundle-analyzer dist/stats.json"
  },
  "private": true,
  "dependencies": {
    "@abacritt/angularx-social-login": "2.3.0",
    "@angular/animations": "19.0.4",
    "@angular/cdk": "19.0.3",
    "@angular/common": "19.0.4",
    "@angular/compiler": "19.0.4",
    "@angular/core": "19.0.4",
    "@angular/fire": "19.0.0",
    "@angular/forms": "19.0.4",
    "@angular/material": "19.0.3",
    "@angular/platform-browser": "19.0.4",
    "@angular/platform-browser-dynamic": "19.0.4",
    "@angular/platform-server": "19.0.4",
    "@angular/pwa": "19.0.5",
    "@angular/router": "19.0.4",
    "@angular/service-worker": "19.0.4",
    "@angular/ssr": "19.0.5",
    "compression": "1.7.4",
    "dotenv": "16.4.5",
    "embla-carousel-angular": "14.1.1",
    "express": "4.19.2",
    "geoip-lite": "1.4.10",
    "html-minifier-terser": "7.2.0",
    "ioredis": "5.4.1",
    "keen-slider": "6.8.6",
    "ng-gallery": "11.0.0",
    "ngx-build-plus": "19.0.0",
    "ngx-cookie-service": "19.0.0",
    "ngx-device-detector": "9.0.0",
    "ngx-extended-pdf-viewer": "22.1.0",
    "ngx-google-analytics": "14.0.1",
    "redis": "4.6.14",
    "rxjs": "7.8.1",
    "slick-carousel": "1.8.1",
    "ts-md5": "1.3.1",
    "ua-parser-js": "1.0.38",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.0.5",
    "@angular-devkit/core": "19.1.8",
    "@angular/cli": "19.0.5",
    "@angular/compiler-cli": "19.0.4",
    "@eslint/js": "9.17.0",
    "@types/express": "4.17.21",
    "@types/jasmine": "5.1.4",
    "@types/node": "20.14.9",
    "ajv": "8.16.0",
    "angular-eslint": "19.0.2",
    "codelyzer": "6.0.2",
    "compression-webpack-plugin": "11.1.0",
    "eslint": "9.16.0",
    "eslint-plugin-align": "0.0.1",
    "globals": "15.14.0",
    "jasmine-core": "5.1.2",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.3",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "prettier": "3.5.2",
    "protractor": "7.0.0",
    "ts-node": "10.9.2",
    "typescript": "5.6.3",
    "typescript-eslint": "8.18.0",
    "webpack-bundle-analyzer": "4.10.2",
    "ws": "8.17.1",
    "xmlhttprequest": "1.8.0"
  }
}
